// extracted by mini-css-extract-plugin
export var centerText = "_c2-8";
export var container = "_c2-0";
export var doughnutContainer = "_c2-7";
export var legend = "_c2-a";
export var legendItemColorDisplay = "_c2-b";
export var legendItemLabel = "_c2-d";
export var legendItemValue = "_c2-c";
export var lg = "_c2-5";
export var maxWidth = "_c2-9";
export var md = "_c2-4";
export var responsive = "_c2-6";
export var sm = "_c2-3";
export var xs = "_c2-2";
export var xxs = "_c2-1";